import { useState } from 'react';
import { PriceComparisonFooter } from '@Features/MaterialRequest/requests/components/ComparisonSheet';
import {
  PriceSelectionItemDto,
  TenderSupplier,
} from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';
import PriceBreakdown from '@Features/MaterialRequest/requests/components/ComparisonSheet/modals/PriceBreakdown/desktop/PriceBreakdownDesktop';
import PriceSelection from '@Features/MaterialRequest/requests/components/ComparisonSheet/PriceSelection/PriceSelection';
import { TenderTotalAmountResponse } from '@Types/api/form/tenderRequest/TenderTotalAmountResponse';

interface SelectedTabDesktopProps {
  comparisonSheetSuppliers: TenderSupplier[];
  selectedSheetOffers: PriceSelectionItemDto[];
  totalAmountData: TenderTotalAmountResponse | undefined;
  handleReviewApprove: () => void;
}

const SelectedTabDesktop: React.FC<SelectedTabDesktopProps> = ({
  handleReviewApprove,
  comparisonSheetSuppliers,
  selectedSheetOffers,
  totalAmountData,
}) => {
  const [showPriceBreakdown, setShowPriceBreakdown] = useState<boolean>(false);

  return (
    <>
      <PriceSelection
        vendors={comparisonSheetSuppliers}
        dataSource={selectedSheetOffers}
        totalItems={selectedSheetOffers.length}
      />
      <div style={{ minWidth: '100%' }}>
        <PriceComparisonFooter
          handleReviewApprove={handleReviewApprove}
          handlePriceBreakdown={() => {
            setShowPriceBreakdown(true);
          }}
          finalAmount={Number(totalAmountData?.finalTotAmount || 0)}
        />
      </div>
      {showPriceBreakdown && totalAmountData && (
        <PriceBreakdown
          total={totalAmountData}
          onClose={() => {
            setShowPriceBreakdown(false);
          }}
        />
      )}
    </>
  );
};

export default SelectedTabDesktop;
